import TextButton from 'components/TextButton'

const InlineButton = ({
  children,
  ...props
}) => {
  return (
    <TextButton
      color="tertiary"
      variant="inherit"
      inline
      {...props}
    >
      {children}
    </TextButton>
  )
}

export default InlineButton